<template>
  <div id="judges">
    <img src="../assets/img/bm_icon_3.png" alt="" class="icon" v-if="type == 1">
    <img src="../assets/img/bm_icon_2.png" alt="" class="icon" v-else>
    <div class="form_wrap">
      <div class="wrap_list">
        <div class="list_title">
          <div class="title">姓名</div>
        </div>
        <div class="list_right">
          <input type="text" class="input" placeholder="请输入您的姓名" v-model="name">
        </div>
      </div>
      <div class="wrap_list">
        <div class="list_title">
          <div class="title">手机号码</div>
        </div>
        <div class="list_right">
          <input type="text" class="input" placeholder="请输入您的手机号" v-model="phone">
        </div>
      </div>
      <div class="wrap_list">
        <div class="list_title">
          <div class="title">身份证号</div>
        </div>
        <div class="list_right">
          <input type="text" class="input" placeholder="请输入您的身份证号码" v-model="idcard">
        </div>
      </div>
      <div class="wrap_list">
        <div class="list_title">
          <div class="title">微信号</div>
        </div>
        <div class="list_right">
          <input type="text" class="input" placeholder="请输入您的微信号" v-model="wechat">
        </div>
      </div>
      <div class="wrap_list">
        <div class="list_title">
          <div class="title">工作单位</div>
        </div>
        <div class="list_right">
          <input type="text" class="input" placeholder="请输入您的工作单位" v-model="company">
        </div>
      </div>
      <div class="wrap_list">
        <div class="list_title">
          <div class="title">常用邮箱</div>
        </div>
        <div class="list_right">
          <input type="text" class="input" placeholder="请输入您的常用邮箱" v-model="email">
        </div>
      </div>
      <div class="wrap_list">
        <div class="list_title">
          <div class="title">职业</div>
        </div>
        <div class="list_right">
          <input type="text" class="input" placeholder="请输入您的职业" v-model="vocation">
        </div>
      </div>
      <div class="wrap_list">
        <div class="list_title">
          <div class="title">所在区域</div>
        </div>
        <div class="list_right noborder">
          <div class="picker" @click="showAddress()">
            <div class="text ellipsis" :class="{'gray': !province}">{{province || '省份'}}</div>
            <img src="../assets/img/icon_xia.png" alt="" class="icon">
          </div>
          <div class="picker" @click="showAddress()">
            <div class="text ellipsis" :class="{'gray': !city}">{{city || '城市'}}</div>
            <img src="../assets/img/icon_xia.png" alt="" class="icon">
          </div>
          <div class="picker" @click="showAddress()">
            <div class="text ellipsis" :class="{'gray': !county}">{{county || '区域'}}</div>
            <img src="../assets/img/icon_xia.png" alt="" class="icon">
          </div>
        </div>
      </div>
      <div class="wrap_list noCenter">
        <div class="list_title">
          <div class="title">简要介绍</div>
        </div>
        <div class="list_right">
          <textarea class="textarea" maxlength="300" v-model="detail" placeholder="请简短介绍一下自己(300字以内)"></textarea>
        </div>
      </div>
      <div class="wrap_list nofixed">
        <div class="list_title">
          <div class="title">上传照片(3M以内)</div>
        </div>
        <div class="list_right noborder">
          <van-uploader v-model="fileList" :after-read="afterRead" :max-size="1024*1024*3" :max-count="1" @oversize="oversize" @delete="deleteImg" />
          <!-- <div class="images">
            <img :src="image" alt="" class="image" v-if="image">
            <img src="../assets/img/icon_add.png" alt="" class="image" v-else>
            <input type="file" accept="image/*" class="file_input" ref="fileInput" @change="uploadImg">
          </div> -->
        </div>
      </div>
      <big-button :click="submit">确认并提交</big-button>
    </div>
    <van-popup v-model="adderssShow" position="bottom">
      <van-area
        :area-list="areaList"
        :visible-item-count="8"
        title="选择区域"
        @cancel="hideAddress"
        @confirm="onAddressConfirm"
        />
    </van-popup>
    <van-popup v-model="ruleShow" position="center" :close-on-click-overlay="false">
      <div class="rule_modal">
        <div class="title">申请须知</div>
        <div class="content" v-html="type == 1 ? rule1 : rule2">
        </div>
        <div class="btns">
          <div class="btn" @click="closeRuleModal()">同意</div>
          <div class="btn" @click="cancel()">拒绝</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import wx from 'weixin-js-sdk';
export default {
  data () {
    return {
      areaList,
      type: this.$route.query.type || 0,
      name: '',
      phone: '', // 手机号
      idcard: '', // 身份证号
      wechat: '', // 微信号
      company: '', // 工作单位
      email: '', // 邮箱
      vocation: '', // 职业
      adderssShow: false,
      province: '', // 省
      city: '', // 市
      county: '', // 县
      detail: '', // 简介
      image: '', // 照片
      fileList: [],
      ruleShow: true,
      rule1: '<p>申请人进行主持人资格认证前，请您务必认真阅读以下条款内容，并自愿接受和同意所有条款的要求:</p><p>1、《新歌来啦》全国海选组委会或其分赛区均有权通过官方网站下载获取或以其他方式收集主持人相关身份等信息。</p><p>2、《新歌来啦》全国海选组委会或其分赛区有权在《新歌来啦》全国海选及音乐经营范围内，无限制、无偿使用申请人提交的信息、材料，包括将该信息用于活动宣传推广、人才统计与推荐、与全国海选及原创音乐制作相关的其他事宜等。</p><p>3、为确保《新歌来啦》全国海选赛事的权威性以及公平、公正性，担任《新歌来啦》主持人员须通过《新歌来啦》全国海选组委会官方资格审查并认证，持有“《新歌来啦》特邀主持资格证”或经全国组委会备案的专业人员方可担任《新歌来啦》主持人。</p><p>4、主持人资质认证流程:</p><p>①登录《新歌来啦》全国官方通道,进入【主持人认证】通道;</p><p>②申请人如实、完整填写个人信息，并提交;</p><p>③全国组委会或分赛区组委会审核申请人信息;</p><p>④审核通过后，官方组委会联系申请人并颁发相关资格证书。</p><p>5、未经《新歌来啦》全国海选官方认证的人员，其所参与的相关活动，不具官方性、真实性。</p><p>6、申请人须严格按照主持人执行要求，坚持公平、公正的原则，认真履行职责，并接受社会监督。</p><p>7、申请人确认并已仔细、认真、慎重审阅以上条款，并同意遵守由《新歌来啦》全国海选组委会或其分赛区制定的各项规则和制度，尊重并接受《新歌来啦》全国海选组委会做出的规划与决定等。</p><p>8、《新歌来啦》主持人认证事宜最终解释权归《新歌来啦》全国海选组委会所有。</p>',
      rule2: '<p>申请人进行评委资格认证前，请您务必认真阅读以下条款内容，并自愿接受和同意所有条款的要求:</p><p>1、《新歌来啦》全国海选组委会或其分赛区均有权通过官方网站下载获取或以其他方式收集评委相关身份等信息。</p><p>2、《新歌来啦》全国海选组委会或其分赛区有权在《新歌来啦》全国海选及音乐经营范围内，无限制、无偿使用申请人提交的信息、材料，包括将该信息用于活动宣传推广、人才统计与推荐、与全国海选及原创音乐制作相关的其他事宜等。</p><p>3、为确保《新歌来啦》全国海选赛事的权威性以及公平、公正性，担任《新歌来啦》评委人员须通过《新歌来啦》全国组委会官方资格审查并认证，持有“《新歌来啦》特邀评委资格证”或经全国组委会备案的专业人员方可担任《新歌来啦》评委。</p><p>4、评委资质认证流程:</p><p>①登录《新歌来啦》全国官方通道,进入【评委认证】通道;</p><p>②申请人如实、完整填写个人信息，并提交;</p><p>③全国组委会或分赛区组委会审核申请人信息;</p><p>④审核通过后，官方组委会联系申请人并颁发相关资格证书。</p><p>5、未经《新歌来啦》全国海选官方认证的人员，其所参与的相关活动，不具官方性、真实性。</p><p>6、申请人须严格按照评委执行要求，坚持公平、公正的原则，认真履行职责，并接受社会监督。</p><p>7、申请人确认并已仔细、认真、慎重审阅以上条款，并同意遵守由《新歌来啦》全国海选组委会或其分赛区制定的各项规则和制度，尊重并接受《新歌来啦》全国海选组委会做出的规划和决定等。</p><p>8、《新歌来啦》评委认证事宜最终解释权归《新歌来啦》全国海选组委会所有。</p>'
    }
  },
  mounted() {
    if (this.$route.query.type == 1) {
      document.title = '主持人认证';
    } else {
      document.title = '评委认证';
    }
    this.editAreaList();
    this.getShareConfig();
  },
  methods: {
    editAreaList () {
      let objString = JSON.stringify(areaList.county_list);
      let newObj = objString.replace(/祁阳县/g, '祁阳市');
      areaList.county_list = JSON.parse(newObj);
    },
    getShareConfig () {
      let link = this.isIos ? this.ios_first_url : location.href.split("#")[0];
      let that = this;
      this.axios.post('/Home/WeAuth/getConfig', {
        url: link
      })
        .then(({data}) => {
          if (data.code === 1) {
            wx.config({
              // debug: true,
              appId: data.data.appId,
              timestamp: data.data.timestamp,
              nonceStr: data.data.nonceStr,
              signature: data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            });
            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                  let options = {
                    title: '新歌来啦官方通道', // 分享标题
                    desc: '为优秀的歌手提供卫星电视的播出平台，欢迎您的参与！', // 分享描述
                    link: location.origin + '/#/', // 分享链接
                    imgUrl: location.origin + '/logo.png', // 分享图标
                    success: function () {
                    // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                    // 用户取消分享后执行的回调函数
                    }
                  }
                  wx.onMenuShareTimeline(options);
                  wx.onMenuShareAppMessage(options);
                  wx.onMenuShareQQ(options);
                  wx.onMenuShareWeibo(options);
                  wx.onMenuShareQZone(options);
                }
              });
            });
          }
        });
    },
    uploadImg (file) {
      // let file = e.target.files[0];
      // if (file.size > 1024 * 1024 * 3) return this.Toast('图片最大为3M');
      let fm = new window.FormData();
      fm.append('logo', file);
      this.axios.post('/api/Index/ReturnLogoInfo', fm, {headers: {'Content-Type': 'multipart/form-data'}, transformRequest: [function (data) { return data; }]})
        .then(({data}) => {
          if (data.code === 1) {
            this.image = data.url;
            this.fileList[0].status = 'done';
            this.fileList[0].message = '上传成功';
          } else {
            this.fileList[0].status = 'failed';
            this.fileList[0].message = '上传失败';
          }
        });
    },
    afterRead (file) {
      console.log(file);
      file.status = 'uploading';
      file.message = '上传中...';
      this.uploadImg(file.file)
      setTimeout(() => {
      }, 1000);
    },
    oversize () {
      this.Toast('图片大小不能超过3M')
    },
    deleteImg () {
      this.image = '';
    },
    showAddress () {
      this.adderssShow = true;
    },
    hideAddress () {
      this.adderssShow = false;
    },
    onAddressConfirm (e) {
      this.province = e[0].name;
      this.city = e[1].name;
      this.county = e[2].name;
      this.hideAddress();
    },
    submit () {
      if (!this.name) return this.Toast('请输入您的姓名');
      if (!this.phone) return this.Toast('请输入您的手机号');
      if (!this.idcard) return this.Toast('请输入您的身份证号码');
      if (!this.wechat) return this.Toast('请输入您的微信号');
      if (!this.province) return this.Toast('请选择所在区域');
      if (!this.image) return this.Toast('请上传照片');
      this.axios.post('/api/Index/SendInfo1', {
        type: this.type,
        name: this.name,
        mobile: this.phone,
        wxtext: this.wechat,
        id_card: this.idcard,
        sponsor: this.company,
        email: this.email,
        sponsor1: this.vocation,
        comment: this.detail,
        dailiprovince: this.province,
        dailicity: this.city,
        dailiarea: this.county,
        url: this.image
      })
        .then(({data}) => {
          if (data.code == 1) {
            setTimeout(() => {
              this.$router.replace('/judgesSuccess');
            }, 1500);
          } else {
            this.Toast(data.msg);
          }
        })
    },
    closeRuleModal () {
      this.ruleShow = false;
    },
    cancel () {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
  #judges{
    background: url('../assets/img/bg.png') no-repeat 0 0 / 100% 2000px;
    .form_wrap{
      padding: 30px 60px 80px;
      .wrap_list{
        display:flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        &.nofixed{
          align-items: flex-start;
          margin-top:20px;
        }
        &.noCenter{
          align-items:flex-start;
        }
        .list_title{
          display:flex;
          align-items: center;
          justify-content: space-between;
          font-weight: bold;
          position:relative;
          padding:0 10px;
          &.after{
            &:before{
              line-height:48px;
              content: '*';
              display:block;
              position:absolute;
              left:-20px;
              top:5px;
              color:#fff;
            }
          }
          &:after{
            line-height:48px;
            content: ':';
            display:block;
            position:absolute;
            right:-15px;
            top:0px;
            color:#fff;
          }
          .title{
            width:140px;
            font-size:28px;
            text-align: justify;
            text-align-last: justify;
            line-height:48px;
            color:#fff;
          }
          span{
            color:#fff;
            font-size:30px;
          }
        }
        .list_right{
          width:400px;
          min-height:60px;
          border-radius: 4px;
          display:flex;
          &.noborder{
            border:0;
            .picker{
              border: 1px solid #e0e0e0;
              width:120px;
              margin-right:20px;
              &:last-child{
                margin-right:0;
              }
            }
            .input{
              width:260px;
            }
          }
          .input{
            width:100%;
            height:60px;
            font-size:24px;
            padding: 0 20px;
            background:#fff;
            border-radius: 40px;
          }
          .textarea{
            width:100%;
            height:200px;
            background:#fff;
            border-radius: 16px;
            padding: 20px;
            resize: none;
          }
          .picker{
            width:100%;
            height:60px;
            padding: 0 10px;
            display:flex;
            align-items: center;
            justify-content: space-between;
            background:#fff;
            border-radius: 40px;
            &.big{
              padding: 0 20px;
              .text{
                font-size:28px;
              }
            }
            .text{
              font-size:20px;
              &.gray{
                color:gray;
              }
            }
            .icon{
              width:16px;
              height:16px;
            }
          }
          .images{
            width:120px;
            height:120px;
            position:relative;
            border-radius: 16px;
            overflow: hidden;
            .image{
              width:100%;
              height:100%;
            }
            .file_input{
              width:100%;
              height:100%;
              opacity: 0;
              position:absolute;
              top:0;
              left:0;
              z-index:1;
            }
          }
        }
      }
    }
    .rule_modal{
      width:650px;
      background:rgba($color: #fff, $alpha: 0.9);
      padding: 50px 40px;
      .title{
        font-size:32px;
        font-weight: bold;
        text-align: center;
      }
      .content{
        margin: 40px 0;
        height:800px;
        overflow-y: auto;
        font-size:30px;
        line-height:48px;
        text-indent: 2em;
        text-align: justify;
      }
      .btns{
        display:flex;
        align-items: center;
        justify-content: space-around;
        padding:0 30px;
        .btn{
          width:160px;
          height:70px;
          background:#fff;
          text-align: center;
          line-height:70px;
          font-size:36px;
          border-radius: 12px;
          border:2px solid #000;
        }
      }
    }
  }
</style>